"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableAttributes = exports.GIFT_NOTE_KEY = exports.getDefaultAttributes = exports.getPlugin = void 0;
const react_1 = require("@sentry/react");
const lib_1 = require("../../lib");
const DefaultProductPlugin = {
    SelectOptionsRenderer: () => null,
    managedSelections: [],
    defaultCustomAttributes: [],
    availableCustomAttributes: [],
    lineItemProperties: [],
    images: () => [],
    validate: defaultValidator,
    showQuantity: false,
};
function getPlugin(plugins, productType) {
    var _a;
    if (productType && !plugins[productType]) {
        (0, react_1.captureMessage)(`No plugin found for product type "${productType}". Check the metafields of this product.`);
    }
    const plugin = (_a = plugins[productType]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({ productType }, DefaultProductPlugin), plugin);
}
exports.getPlugin = getPlugin;
function getDefaultAttributes(plugin, selectedOptions) {
    if (Array.isArray(plugin.defaultCustomAttributes)) {
        return plugin.defaultCustomAttributes;
    }
    else {
        return plugin.defaultCustomAttributes(selectedOptions);
    }
}
exports.getDefaultAttributes = getDefaultAttributes;
exports.GIFT_NOTE_KEY = "Gift Note";
const UNIVERSAL_ATTRIBUTES = [
    {
        key: exports.GIFT_NOTE_KEY,
        required: false,
    },
];
function getAvailableAttributes(plugin, selectedOptions, customAttributes) {
    if (Array.isArray(plugin.availableCustomAttributes)) {
        return [...UNIVERSAL_ATTRIBUTES, ...plugin.availableCustomAttributes];
    }
    else {
        return [
            ...UNIVERSAL_ATTRIBUTES,
            ...plugin.availableCustomAttributes({
                selectedOptions,
                customAttributes,
            }),
        ];
    }
}
exports.getAvailableAttributes = getAvailableAttributes;
function defaultValidator({ customAttributes, availableAttributes, }) {
    const customAttributesMap = (0, lib_1.attributesToMap)(customAttributes);
    return availableAttributes.every(attribute => {
        if (attribute.required !== false && !customAttributesMap[attribute.key]) {
            return false;
        }
        return true;
    });
}
//# sourceMappingURL=data:application/json;base64,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